import LoyaltyInfo from './components/LoyaltyInfo.css';
import Card from './components/Card/Card.css';
import Menu from './components/Menu/Menu.css';
import FfpInfo from './components/FfpInfo/FfpInfo.css';
import LoyaltyInfoV2 from '../LoyaltyInfoV2/theme';

export default {
	LoyaltyInfo,
	LoyaltyInfoV2,
	Card,
	Menu,
	FfpInfo
};
